import { useMutation, useQuery } from '@tanstack/react-query';

import { useTheme } from '@/shared/providers/theme/ThemeContext';
import { useClinicContext } from '@/hooks/main/useClinicContext';
import {
  fetchConsentDocumentPrintInit,
  outputConsentDocumentPrintPdf,
  type ConsentDocumentPrintPayload,
} from '@/pages/main/consent/services/print';

export const useConsentDocumentPrintInit = (consentId: number, documentTypeId: number, enabled = false) => {
  const { tenant, clinicNumber } = useClinicContext();
  const { serviceType } = useTheme();

  return useQuery({
    queryKey: ['consent-document-print', 'init', tenant, clinicNumber, consentId, documentTypeId, serviceType],
    queryFn: () =>
      fetchConsentDocumentPrintInit(tenant, clinicNumber, consentId, documentTypeId, serviceType),
    enabled: enabled && !!consentId && !!documentTypeId,
  });
};

export const useConsentDocumentPrintOutput = (consentId: number) => {
  const { tenant, clinicNumber } = useClinicContext();
  const { serviceType } = useTheme();

  return useMutation({
    mutationFn: (payload: ConsentDocumentPrintPayload) =>
      outputConsentDocumentPrintPdf(tenant, clinicNumber, consentId, payload, serviceType),
  });
};
